import PropTypes from 'prop-types';
import { memo, useCallback, useState } from 'react';

import { APP_SETTINGS } from '../../../app-settings';
import { IconTeamPlaceholder } from '../../icons/icon';
import { Image } from '../../image/image';

function TeamLogoPlaceholderUI({ isHome, className, height, width }) {
  const [isImageNotFound, setIsImageNotFound] = useState(false);

  const onError = useCallback(() => setIsImageNotFound(true), []);

  if (isImageNotFound) {
    return <IconTeamPlaceholder className={className} height={height} width={width} />;
  }

  return (
    <Image
      className={className}
      height={height}
      src={`${APP_SETTINGS.PROJECT_CDN_URL}/team-logo/${isHome ? 'home' : 'away'}.png`}
      width={width}
      onError={onError}
    />
  );
}

TeamLogoPlaceholderUI.propTypes = {
  isHome: PropTypes.bool,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

TeamLogoPlaceholderUI.defaultProps = {
  className: undefined,
  height: undefined,
  width: undefined,
  isHome: undefined,
};

export const TeamLogoPlaceholder = memo(TeamLogoPlaceholderUI);
